import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 0 };
import DataInconsistencyHeader from '@/features/DataInconsistency/components/DataInconsistencyHeader/DataInconsistencyHeader.vue';
import DataInconsistencyTable from '@/features/DataInconsistency/components/DataInconsistencyTable/DataInconsistencyTable.vue';
import DataInconsistencyCountLine from '@/features/DataInconsistency/components/DataInconsistencyCountLine/DataInconsistencyCountLine.vue';
import DataInconsistencyStateNoTestsFound from '@/features/DataInconsistency/components/DataInconsistencyStates/DataInconsistencyStateNoTestsFound.vue';
import DataInconsistencyStateAllTestsPassed from '@/features/DataInconsistency/components/DataInconsistencyStates/DataInconsistencyStateAllTestsPassed.vue';
import LoaderSpinner from '@/components/_atoms/BaseLoaderSpinner.vue';
import InfoCard from '@/components/_atoms/InfoCard.vue';
import DataInconsistencyLastUpdate from '@/features/DataInconsistency/components/DataInconsistencyLastUpdate/DataInconsistencyLastUpdate.vue';
// types
import { StatusTests } from '@/features/DataInconsistency/types';
// services
import { fetchDataInconsistency } from '@/features/DataInconsistency/services';
// libs
import { ref, onMounted, computed, watch } from 'vue';
import { useStore } from 'vuex';
// utils
import { useMixpanelDataInconsistency } from '@/utilities/mixpanel';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DataInconsistency',
    setup(__props) {
        // components
        const store = useStore();
        const isLoading = ref(false);
        const hasError = ref(false);
        const isLoadingExport = ref(false);
        const tableData = ref({
            status: '',
            lines: 0,
            data: [],
            series: [],
            totalCount: '',
            lastUpdate: '',
        });
        const isExporting = (isLoading) => {
            isLoadingExport.value = isLoading;
        };
        const selectedBrand = computed(() => store.state?.auth?.selectedBrand?.brand);
        watch(selectedBrand, () => {
            fetchTableData();
        });
        onMounted(() => {
            useMixpanelDataInconsistency('view_integrations_data_inconsistency');
            fetchTableData();
        });
        const fetchTableData = () => {
            isLoading.value = true;
            hasError.value = false;
            fetchDataInconsistency()
                .then(response => {
                tableData.value.series = response?.series;
                tableData.value.data = response?.data;
                tableData.value.status = response?.status;
                tableData.value.lines = response?.data.length;
                tableData.value.totalCount = response?.totalCount;
                tableData.value.lastUpdate = response?.lastUpdate;
            })
                .catch(() => {
                hasError.value = true;
            })
                .finally(() => {
                isLoading.value = false;
            });
        };
        const showTableOrState = (value) => {
            return value === tableData.value.status;
        };
        return (_ctx, _cache) => {
            const _component_base_card_v2 = _resolveComponent("base-card-v2");
            return (_openBlock(), _createBlock(_component_base_card_v2, { id: "data-inconsistency" }, {
                default: _withCtx(() => [
                    (!isLoading.value && !hasError.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createVNode(DataInconsistencyHeader, {
                                "show-button-export": showTableOrState(_unref(StatusTests).FAILED_TESTS),
                                onIsLoadingExport: isExporting
                            }, null, 8, ["show-button-export"]),
                            (showTableOrState(_unref(StatusTests).FAILED_TESTS))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                    _createVNode(DataInconsistencyLastUpdate, {
                                        "last-update": tableData.value.lastUpdate
                                    }, null, 8, ["last-update"]),
                                    _createVNode(DataInconsistencyTable, { "data-table": tableData.value }, null, 8, ["data-table"]),
                                    _createVNode(DataInconsistencyCountLine, {
                                        "count-line": tableData.value.lines,
                                        "total-count": tableData.value.totalCount
                                    }, null, 8, ["count-line", "total-count"])
                                ]))
                                : _createCommentVNode("", true),
                            (showTableOrState(_unref(StatusTests).NO_TESTS_FOUND))
                                ? (_openBlock(), _createBlock(DataInconsistencyStateNoTestsFound, { key: 1 }))
                                : _createCommentVNode("", true),
                            (showTableOrState(_unref(StatusTests).ALL_TESTS_PASSED))
                                ? (_openBlock(), _createBlock(DataInconsistencyStateAllTestsPassed, { key: 2 }))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    (!isLoading.value && hasError.value)
                        ? (_openBlock(), _createBlock(InfoCard, {
                            key: 1,
                            ref: "message-error",
                            error: hasError.value
                        }, null, 8, ["error"]))
                        : _createCommentVNode("", true),
                    (isLoading.value || isLoadingExport.value)
                        ? (_openBlock(), _createBlock(LoaderSpinner, {
                            key: 2,
                            color: isLoadingExport.value ? 'colored-block' : '',
                            class: _normalizeClass(isLoadingExport.value ? 'render-loader' : '')
                        }, null, 8, ["color", "class"]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
